/**
 * Lightweight chunk prefetcher for lazy-loaded routes.
 *
 * Usage:
 *   <Link to="/about" onMouseEnter={() => prefetchRoute("about")} ... />
 *
 * Each route is fetched at most once per session.
 */
const cache = new Set<string>();

type RouteKey =
  | "about"
  | "blog"
  | "contact"
  | "pricing"
  | "courses"
  | "faq"
  | "support";

const loaders: Record<RouteKey, () => Promise<unknown>> = {
  about: () => import("@/pages/About"),
  blog: () => import("@/pages/Blog"),
  contact: () => import("@/pages/Contact"),
  pricing: () => import("@/pages/Pricing"),
  courses: () => import("@/pages/Courses"),
  faq: () => import("@/pages/FAQ"),
  support: () => import("@/pages/Support"),
};

export function prefetchRoute(route: RouteKey): void {
  if (cache.has(route)) return;
  cache.add(route);
  // Fire-and-forget; swallow errors silently (network blips shouldn't surface)
  loaders[route]().catch(() => cache.delete(route));
}
